import { useI18n } from '@/lib/i18n'
import { useSectionHeading } from '@/lib/primarySection'
import './FAQSection.css'
import FAQItem from './FAQItem'

type FAQ = { id: string; question: string; answer: string }
type Content = { eyebrow: string; faqTitle: string; lede: string; faq: FAQ[] }

export default function FAQSection() {
  const { section } = useI18n()
  const c = section('faq') as unknown as Content
  const faqs = Array.isArray(c.faq) ? c.faq : []

  const { Tag: Title, className: titleClass } = useSectionHeading('faq', 'h2')

  return (
    <section className="section" aria-labelledby="faq-title">
      <div className="split">
        <div className="split__aside">
          <span className="eyebrow">{c.eyebrow}</span>
          <Title id="faq-title" className={titleClass} style={{ marginTop: 12 }}>
            {c.faqTitle}
          </Title>
          <p className="lede" style={{ marginTop: 20 }}>
            {c.lede}
          </p>
        </div>
        <div className="faq__list">
          {faqs.map((f) => (
            <FAQItem key={f.id} question={f.question} answer={f.answer} />
          ))}
        </div>
      </div>
    </section>
  )
}
